import React from 'react';

const GlobalSchema = () => {
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "HomeAndConstructionBusiness",
    "@id": "https://handwerkernotdienst.nrw/#organization",
    "name": "Handwerkernotdienst NRW – Schössow Dienstleistungen UG (haftungsbeschränkt)",
    "legalName": "Schössow Dienstleistungen UG (haftungsbeschränkt)",
    "url": "https://handwerkernotdienst.nrw",
    "logo": "https://handwerkernotdienst.nrw/logo.png",
    "image": "https://customer-assets.emergentagent.com/job_repair-hero-4/artifacts/xsv6bl5n_bunner1.jpg",
    "description": "24/7 Handwerkernotdienst im Raum Dortmund und Umgebung. Schlüsseldienst, Elektro-Notdienst, Sanitär, Rohrreinigung, Glas-Notdienst und Einbruchschutz.",
    "telephone": "+49-231-39083687",
    "email": "info@handwerkernotdienst.nrw",
    "founder": {
      "@type": "Person",
      "name": "Andreas Schoessow"
    },
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Neben dem Brand 10",
      "addressLocality": "Dortmund",
      "postalCode": "44135",
      "addressRegion": "Nordrhein-Westfalen",
      "addressCountry": "DE"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "51.5078845",
      "longitude": "7.4702625"
    },
    "areaServed": [
      {
        "@type": "City",
        "name": "Dortmund",
        "addressRegion": "Nordrhein-Westfalen",
        "addressCountry": "DE"
      },
      {
        "@type": "City",
        "name": "Bochum",
        "addressRegion": "Nordrhein-Westfalen",
        "addressCountry": "DE"
      },
      {
        "@type": "City",
        "name": "Essen",
        "addressRegion": "Nordrhein-Westfalen",
        "addressCountry": "DE"
      },
      {
        "@type": "State",
        "name": "Nordrhein-Westfalen",
        "addressCountry": "DE"
      }
    ],
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday"
        ],
        "opens": "00:00",
        "closes": "23:59"
      }
    ],
    "sameAs": [
      "https://www.youtube.com/@Handwerkernotdienst",
      "https://www.tiktok.com/@handwerkernotdienst.nrw",
      "https://www.google.com/maps/place/Handwerkernotdienst.nrw/@51.5079827,7.3054521,27895m/data=!3m2!1e3!4b1!4m6!3m5!1s0x2c44deb7de2690b3:0x94f2797019a9355e!8m2!3d51.5078845!4d7.4702625!16s%2Fg%2F11xm_663l8"
    ],
    "priceRange": "Auf Anfrage",
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.8",
      "reviewCount": "127"
    }
  };

  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "@id": "https://handwerkernotdienst.nrw/#website",
    "url": "https://handwerkernotdienst.nrw",
    "name": "Handwerkernotdienst NRW",
    "description": "24/7 Handwerkernotdienst im Raum Dortmund und Umgebung",
    "publisher": {
      "@id": "https://handwerkernotdienst.nrw/#organization"
    },
    "potentialAction": {
      "@type": "SearchAction",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": "https://handwerkernotdienst.nrw/einsatzgebiete?q={search_term_string}"
      },
      "query-input": "required name=search_term_string"
    }
  };

  return (
    <>
      {/* JSON-LD Schema Markup - React 19 automatically hoists to head */}
      <script 
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
      <script 
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      
      {/* Open Graph Meta Tags */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Handwerkernotdienst NRW" />
      <meta property="og:locale" content="de_DE" />
      
      {/* Twitter Card Meta Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@handwerkernotdienst" />
      
      {/* Social Media Profile Links */}
      <link rel="me" href="https://www.youtube.com/@Handwerkernotdienst" />
      <link rel="me" href="https://www.tiktok.com/@handwerkernotdienst.nrw" />
    </>
  );
};

export default GlobalSchema;
